import { ManageDiagnostic } from "apps/diagnostics/components/manageDiagnostic/ManageDiagnostic";
import { Constants } from "common/constants";
import { UserAuthGuard } from "components/authguard/UserAuthGuard";
import { DiagnosticsPage } from "pages/diagnostics";
import { RouteObject } from "react-router-dom";
import {
  MICROPHONE_HELP_URL,
  TERMS_AND_CONDITIONS_URL,
} from "./externalDiagnostics/externalDiagnosticsConsent/externalDiagnosticsConsent";
import { ExternalDiagnosticsPage } from "./pages/externalDiagnostics/ExternalDiagnosticsPage";
import { MicrophoneHelp } from "./pages/microphoneHelp/MicrophoneHelp";
import { TermsOfUsePage } from "./pages/termsOfUse/TermsOfUsePage";

export const DiagnosticsRoutes: RouteObject[] = [
  {
    path: "/diagnostics",
    handle: { pageTitle: "AI Interviews" },
    element: (
      <UserAuthGuard
        component={<DiagnosticsPage />}
        anyOf={[Constants.DIAGNOSTICS_USERS_GROUP_NAME_VALUE]}
      />
    ),
  },

  {
    handle: { nhDiagnostics: true },
    children: [
      {
        path: "/external-diagnostics/:id/question/next",
        element: <ExternalDiagnosticsPage />,
      },
      {
        path: "/external-diagnostics/question/next",
        element: <ExternalDiagnosticsPage />,
      },
      {
        path: "/diagnostics/terms",
        element: <TermsOfUsePage />,
      },
      {
        path: TERMS_AND_CONDITIONS_URL,
        element: <TermsOfUsePage />,
      },
      {
        path: "/diagnostic/:id",
        element: (
          <UserAuthGuard
            component={<ManageDiagnostic />}
            anyOf={[Constants.DIAGNOSTICS_USERS_GROUP_NAME_VALUE]}
          />
        ),
      },
      {
        path: MICROPHONE_HELP_URL,
        element: <MicrophoneHelp />,
      },
    ],
  },
];
